import PestPillarLayout from "./PestPillarLayout";

const CRITERIA = [
  {
    title: "1. Certification Certibiocide",
    desc: "Obligatoire depuis 2015 pour appliquer un biocide à titre professionnel. Une entreprise non certifiée est illégale — exigez systématiquement le numéro d'agrément.",
  },
  {
    title: "2. Devis clair et écrit",
    desc: "Détail des produits, dosages, temps d'intervention. Fuyez les tarifs oraux au téléphone sans visite préalable — c'est le premier signal d'une surfacturation à venir.",
  },
  {
    title: "3. Avis Google vérifiés",
    desc: "Au minimum 10 avis avec des noms de commune et des cas concrets. Plus de 4,8/5 en moyenne. Un profil Google Business complet et actif est un signe de sérieux.",
  },
  {
    title: "4. Ancrage local",
    desc: "Une entreprise implantée en Creuse connaît le climat, les espèces locales (frelon asiatique, chenille processionnaire, campagnol) et intervient rapidement.",
  },
  {
    title: "5. Diversité des méthodes",
    desc: "Une entreprise moderne combine vapeur sèche 180 °C (sans produit), gel appâts intelligents, pulvérisation ciblée. Fuyez les prestataires qui ne proposent qu'une seule solution.",
  },
  {
    title: "6. Suivi post-intervention",
    desc: "Punaises de lit ou dératisation exigent un contrôle 15-30 jours après. Une entreprise sérieuse inclut ce suivi et garantit le résultat avec 2ème passage gratuit.",
  },
  {
    title: "7. Attestation d'intervention",
    desc: "Document remis en fin de mission, obligatoire pour bailleurs, assurances et professionnels HACCP. Sans certificat, votre intervention n'a aucune valeur légale.",
  },
  {
    title: "8. Éthique environnementale",
    desc: "Privilégier la méthode la moins invasive possible avant les biocides. Une entreprise responsable protège la biodiversité et vos animaux domestiques.",
  },
];

const FAQ = [
  {
    q: "Comment savoir si une entreprise anti-nuisibles est certifiée ?",
    a: "Vous pouvez demander directement le numéro d'agrément Certibiocide. Ce certificat est obligatoire depuis 2015 pour tout professionnel manipulant des biocides. Il est également possible de vérifier via le registre national des applicateurs de biocides (site du ministère de la Transition écologique).",
  },
  {
    q: "Quel est le prix moyen d'une intervention anti-nuisibles en Creuse ?",
    a: "Comptez 90-180 € pour un nid de guêpes ou frelons accessible, 150-450 € pour un traitement anti-punaises de lit selon la surface, 200-350 € pour une dératisation classique, 100-200 € pour cafards en cuisine. Consultez notre article détaillé sur les prix pour tous les tarifs.",
  },
  {
    q: "Faut-il choisir une entreprise nationale ou locale ?",
    a: "Une entreprise locale est presque toujours préférable : réactivité (intervention sous 24-48 h), connaissance des espèces locales, tarif transparent (pas de commission de tête de réseau), relation directe avec le technicien qui interviendra. Les grandes enseignes nationales imposent souvent des franchisés sans expérience locale.",
  },
  {
    q: "Quelles questions poser avant de signer un devis ?",
    a: "Cinq questions essentielles : (1) Êtes-vous Certibiocide ? (2) Quels produits/méthodes allez-vous utiliser ? (3) Y a-t-il un 2ème passage inclus ? (4) Combien de temps avant que je puisse revenir dans les pièces ? (5) Fournissez-vous une attestation ? Une entreprise sérieuse répondra clairement à chacune.",
  },
  {
    q: "Comment reconnaître une arnaque au démarchage ?",
    a: "Méfiez-vous du démarchage téléphonique agressif (« vous avez droit à une intervention subventionnée »), des interventions urgentes non demandées, ou des tarifs très bas pour appâter puis surfacturés (« finalement le nid était plus haut »). Toute intervention doit être précédée d'une visite gratuite et d'un devis écrit signé.",
  },
  {
    q: "Peut-on comparer plusieurs devis ?",
    a: "Bien sûr, et c'est même conseillé. Cependant, comparez à service équivalent : nombre de passages inclus, produits utilisés, méthodes (vapeur ou chimique), garantie de résultat. Le moins cher n'est jamais le meilleur choix quand il s'agit de nuisibles.",
  },
];

const PROBLEMS = [
  {
    title: "K'REUSE EXTÉRIEUR coche ces 8 cases",
    desc: "Certibiocide, devis écrit clair, 25 avis Google 5,0/5, ancré à La Celle-Dunoise (23), méthodes diversifiées (vapeur sèche + biocides), suivi systématique, attestation remise, approche éthique.",
  },
  {
    title: "Ancrage local depuis La Celle-Dunoise",
    desc: "Nous connaissons chaque commune de la Creuse et intervenons également en Haute-Vienne (87), Indre (36), Allier (03). Interventions sous 24-48 h, sans frais de déplacement.",
  },
  {
    title: "Une seule interlocuteur",
    desc: "Vous parlez directement à Kevin, le fondateur, du 1er contact à la fin de l'intervention. Pas de sous-traitance, pas de standard téléphonique, pas de commercial en costume.",
  },
  {
    title: "Transparence tarifaire totale",
    desc: "Grille tarifaire publiée en ligne, devis écrit avant démarrage, aucune surprise. Consultez notre article dédié aux prix pour tout savoir avant même de nous appeler.",
  },
];

export default function MeilleureEntrepriseNuisibles() {
  return (
    <PestPillarLayout
      slug="meilleure-entreprise-anti-nuisibles-creuse"
      seoTitle="Meilleure entreprise anti-nuisibles Creuse | K'REUSE"
      seoDescription="Comment choisir la meilleure entreprise anti-nuisibles Creuse : 8 critères objectifs (Certibiocide, avis, tarifs transparents)."
      breadcrumbLabel="Meilleure entreprise anti-nuisibles"
      heroBadge="Guide de choix · 8 critères objectifs"
      heroTitleHtml={`Comment choisir la <span class="font-medium text-[#1B5E20]">meilleure entreprise</span> anti-nuisibles en Creuse ?`}
      heroSubtitle="Certifications, tarifs, méthodes, suivi : les 8 critères objectifs pour ne pas vous tromper. Guide honnête rédigé par un professionnel Certibiocide local."
      hero_h2="8 critères pour choisir la bonne entreprise"
      introParagraphs={[
        "Le marché de la lutte anti-nuisibles compte en France plus de 2 500 entreprises, dont la qualité varie énormément. Entre les franchisés nationaux souvent chers et impersonnels, les particuliers non certifiés qui interviennent en marge de la loi, et les vrais professionnels locaux compétents, il n'est pas facile de choisir.",
        "Ce guide vous donne 8 critères objectifs et vérifiables pour distinguer une entreprise sérieuse d'une arnaque, ou d'un prestataire simplement médiocre. Il est rédigé par Kevin, fondateur de K'REUSE EXTÉRIEUR à La Celle-Dunoise (23800), certifié Certibiocide.",
      ]}
      problems={CRITERIA}
      method={PROBLEMS}
      cities={["Guéret", "Aubusson", "La Souterraine", "Bourganeuf", "Boussac", "La Celle-Dunoise", "Felletin", "Bénévent-l'Abbaye", "Dun-le-Palestel", "Sainte-Feyre"]}
      faq={FAQ}
      ctaTitle="Vérifiez nos 8 critères. Puis appelez."
      whatsappText="Bonjour, je souhaite un devis pour une intervention anti-nuisibles en Creuse."
    />
  );
}
